module.exports = __webpack_public_path__ + "img/05-0可乐24小时.6d7d36ac.png";